module.exports = __webpack_public_path__ + "static/media/follow-on-twitter.c2a0064f.png";